/* ==========================================================================
   Snapzyy — the new sections. Vanilla, no dependencies.

   Every page works without this file: links go where they say, the product
   form submits a plain variant list and the cart page has − and + links.
   This adds the menu, the picker, the product builder, live dates, the
   Instagram player and the cart drawer.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function readJSON(node) {
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function press(list, test) {
    list.forEach(function (b, i) { b.setAttribute('aria-pressed', test(b, i) ? 'true' : 'false'); });
  }
  function uniq(list) {
    var out = [];
    list.forEach(function (x) { if (out.indexOf(x) < 0) out.push(x); });
    return out;
  }

  var CART_CFG = readJSON($('[data-sy-cart-config]')) || { labels: {} };
  var CURRENCY = CART_CFG.money || 'INR';

  /* ₹1,159 — whole rupees, no paise, the way the design shows prices */
  function money(cents, cur) {
    cur = cur || CURRENCY;
    var n = (cents || 0) / 100;
    if (cur === 'INR') return '₹' + n.toLocaleString('en-IN', { maximumFractionDigits: 2 });
    try {
      return n.toLocaleString(undefined, { style: 'currency', currency: cur, maximumFractionDigits: 2 });
    } catch (e) {
      return n.toFixed(2);
    }
  }

  /* -------------------------------------------------------------- dates */

  function plusDays(n) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    d.setDate(d.getDate() + n);
    return d;
  }
  function fmtDay(d) { return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }); }
  function fmtMon(d) { return d.toLocaleDateString('en-IN', { month: 'short' }).toUpperCase(); }
  function isoDay(d) {
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }

  // The page was printed when Shopify built it; a cached copy can be days
  // old. These put in the shopper's own today.
  function initDates() {
    $$('[data-sy-mon]').forEach(function (n) { n.textContent = fmtMon(plusDays(+n.getAttribute('data-sy-mon'))); });
    $$('[data-sy-day]').forEach(function (n) { n.textContent = plusDays(+n.getAttribute('data-sy-day')).getDate(); });
    $$('[data-sy-date]').forEach(function (n) {
      n.textContent = (n.getAttribute('data-prefix') || '') + fmtDay(plusDays(+n.getAttribute('data-sy-date')));
    });
    $$('[data-sy-range]').forEach(function (n) {
      var p = n.getAttribute('data-sy-range').split(',');
      n.textContent = fmtDay(plusDays(+p[0])) + ' to ' + fmtDay(plusDays(+p[1]));
    });
  }

  function initDateCheck() {
    $$('[data-sy-datecheck]').forEach(function (box) {
      if (!once(box, 'bound')) return;
      var input = $('[data-sy-need]', box);
      var out = $('[data-sy-need-out]', box);
      if (!input || !out) return;
      var lead = parseInt(box.getAttribute('data-lead'), 10) || 14;
      var original = out.textContent;
      input.min = isoDay(plusDays(1));

      input.addEventListener('change', function () {
        out.classList.remove('is-ok', 'is-tight');
        if (!input.value) { out.textContent = original; return; }
        var target = new Date(input.value + 'T12:00:00');
        var days = Math.round((target - plusDays(0)) / 864e5);
        if (days >= lead) {
          var by = new Date(target);
          by.setDate(by.getDate() - lead);
          out.textContent = (out.getAttribute('data-ok') || '').replace('{date}', fmtDay(by)).replace('{need}', fmtDay(target));
          out.classList.add('is-ok');
        } else {
          out.textContent = out.getAttribute('data-tight') || '';
          out.classList.add('is-tight');
        }
      });
    });
  }

  /* --------------------------------------------------------------- menu */

  function initMenu() {
    var menu = $('[data-sy-menu]');
    if (!menu) return;
    var openers = $$('[data-sy-menu-open]');
    var back = null;

    function open() {
      back = document.activeElement;
      menu.hidden = false;
      document.body.classList.add('sy-lock');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var c = $('[data-sy-menu-close]', menu);
      if (c) c.focus();
    }
    function close() {
      if (menu.hidden) return;
      menu.hidden = true;
      document.body.classList.remove('sy-lock');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (back && back.focus) back.focus();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-sy-menu-close]', menu).forEach(function (b) { b.addEventListener('click', close); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var wide = window.matchMedia('(min-width: 900px)');
    if (wide.addEventListener) wide.addEventListener('change', function (m) { if (m.matches) close(); });
  }

  // The theme editor re-runs setup after it redraws a section; this keeps
  // anything already wired from being wired twice.
  function once(node, key) {
    if (node.getAttribute('data-sy-' + key)) return false;
    node.setAttribute('data-sy-' + key, '1');
    return true;
  }

  /* ---------------------------------------------------- hero, bars, tabs */

  function initHeroVideo() {
    $$('.sy-hero__video').forEach(function (v) {
      v.muted = true;
      if (REDUCED) { v.removeAttribute('autoplay'); v.pause(); return; }
      var p = v.play && v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function initBars() {
    $$('[data-sy-bar]').forEach(function (bar) {
      document.body.classList.add('sy-has-bar');
      if (!once(bar, 'bound')) return;
      var sel = bar.getAttribute('data-sy-bar-watch');
      var target = sel ? document.querySelector(sel) : null;
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-away', en.isIntersecting); });
      }).observe(target);
    });
  }

  function initTabs() {
    $$('[data-sy-tabs-scope]').forEach(function (scope) {
      if (!once(scope, 'bound')) return;
      var btns = $$('[data-sy-tab]', scope);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var g = b.getAttribute('data-sy-tab');
          press(btns, function (x) { return x === b; });
          $$('[data-sy-group]', scope).forEach(function (f) { f.hidden = f.getAttribute('data-sy-group') !== g; });
          var rail = $('.sy-rail', scope);
          if (rail) rail.scrollLeft = 0;
        });
      });
    });
  }

  function initOpeners() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-sy-open]');
      if (!b) return;
      var t = document.querySelector(b.getAttribute('data-sy-open'));
      if (!t) return;
      t.hidden = false;
      t.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
      var f = t.querySelector('textarea, input[type="text"]');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, REDUCED ? 0 : 350);
    });
  }

  /* ---------------------------------------------------- Instagram player */

  function initReels() {
    var dlg = $('[data-sy-igdialog]');
    if (!dlg) return;
    var frame = $('[data-sy-igframe]', dlg);

    function shut() {
      if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
      frame.src = 'about:blank';
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-sy-ig]');
      if (!b) return;
      e.preventDefault();
      frame.src = b.getAttribute('data-sy-ig');
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    });
    $('[data-sy-igclose]', dlg).addEventListener('click', shut);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) shut(); });
    dlg.addEventListener('close', function () { frame.src = 'about:blank'; });

    // Only one reel plays at a time.
    document.addEventListener('play', function (e) {
      if (!e.target.closest || !e.target.closest('.sy-reel')) return;
      $$('.sy-reel video').forEach(function (v) { if (v !== e.target) v.pause(); });
    }, true);
  }

  /* ------------------------------------------------ pages for a photo count */

  // "A5:22,40,60|A4:22,40,60" → { A5: [22, 40, 60], A4: [22, 40, 60] }
  function parseTiers(text) {
    var map = null;
    String(text || '').split('|').forEach(function (part) {
      var kv = part.split(':');
      if (kv.length < 2) return;
      map = map || {};
      map[kv[0].trim()] = kv[1].split(',').map(function (n) { return parseInt(n, 10); });
    });
    return map;
  }
  var TIER_INDEX = { s: 0, m: 1, l: 2 };

  function nearest(list, target, get) {
    var best = null, gap = Infinity;
    list.forEach(function (x) {
      var d = Math.abs(get(x) - target);
      if (d < gap || (d === gap && get(x) > get(best))) { best = x; gap = d; }
    });
    return best;
  }

  /* ------------------------------------------------------------- picker */

  function initPicker() {
    $$('[data-sy-picker]').forEach(function (root) {
      if (!once(root, 'bound')) return;
      var data = readJSON($('[data-sy-picker-data]', root));
      if (!data || !data.books) return;
      var books = data.books;
      var occ = data.occasions || [];
      Object.keys(books).forEach(function (k) { books[k].tierMap = parseTiers(books[k].tiers); });

      var st = { occ: 0, book: 'pb', tier: 'm', size: 'A5' };
      var occBtns = $$('[data-sy-occ]', root);
      var bookBtns = $$('[data-sy-book]', root);
      var tierBtns = $$('[data-sy-tier]', root);
      var which = $('[data-sy-which]', root);
      var tiersBox = $('[data-sy-tiers]', root);
      var fmtEl = $('[data-sy-rec-fmt]', root);
      var whyEl = $('[data-sy-rec-why]', root);
      var sizesEl = $('[data-sy-rec-sizes]', root);
      var fixedEl = $('[data-sy-rec-fixed]', root);
      var fixedPrice = $('[data-sy-rec-fixedprice]', root);
      var cta = $('[data-sy-rec-cta]', root);
      var alt = $('[data-sy-rec-alt]', root);

      function hasPages(b) { return (b.variants || []).some(function (v) { return v.pages > 0; }); }
      function kindNow() {
        var o = occ[st.occ] || {};
        var k = o.book === 'custom' ? st.book : o.book;
        if (!books[k] || !books[k].exists) k = books.pb && books.pb.exists ? 'pb' : 'mg';
        return k;
      }
      function pick(b, size, tier) {
        var lane = b.variants.filter(function (v) { return v.size === size && v.available; });
        if (!lane.length) return null;
        var row = b.tierMap && b.tierMap[size];
        var target = row ? row[TIER_INDEX[tier]] : lane[Math.floor(lane.length / 2)].pages;
        return nearest(lane, target, function (v) { return v.pages; });
      }

      function render(focusSize) {
        var o = occ[st.occ] || {};
        var k = kindNow();
        var b = books[k];
        if (!b) return;
        var custom = o.book === 'custom';
        var fixed = !hasPages(b);

        press(occBtns, function (x, i) { return i === st.occ; });
        if (which) which.hidden = !custom;
        press(bookBtns, function (x) { return x.getAttribute('data-sy-book') === k; });
        if (tiersBox) tiersBox.hidden = fixed;
        press(tierBtns, function (x) { return x.getAttribute('data-sy-tier') === st.tier; });

        fmtEl.textContent = b.name;
        whyEl.textContent = custom ? b.why : (o.why || b.why);

        var href = b.url;
        var price = null;
        sizesEl.textContent = '';
        if (fixed) {
          sizesEl.hidden = true;
          fixedEl.hidden = false;
          var v0 = b.variants.filter(function (v) { return v.available; })[0] || b.variants[0];
          if (v0) {
            href = b.url + '?variant=' + v0.id;
            price = v0.price;
            if (fixedPrice) fixedPrice.textContent = money(v0.price, data.money);
          }
        } else {
          sizesEl.hidden = false;
          fixedEl.hidden = true;
          var sizes = uniq(b.variants.map(function (v) { return v.size; })).filter(Boolean);
          if (sizes.indexOf(st.size) < 0) st.size = sizes[0];
          sizes.forEach(function (sz) {
            var v = pick(b, sz, st.tier);
            var btn = el('button', 'sy-size');
            btn.type = 'button';
            btn.setAttribute('aria-pressed', sz === st.size ? 'true' : 'false');
            btn.appendChild(el('span', 'sy-size__id', sz));
            btn.appendChild(el('span', 'sy-size__sub', v ? v.pages + ' ' + data.pagesWord : ''));
            btn.appendChild(el('span', 'sy-size__price', v ? money(v.price, data.money) : 'Sold out'));
            btn.addEventListener('click', function () { st.size = sz; render(sz); });
            sizesEl.appendChild(btn);
            if (focusSize === sz) btn.focus();
          });
          var cur = pick(b, st.size, st.tier);
          if (cur) {
            href = b.url + '?variant=' + cur.id + '&photos=' + st.tier;
            price = cur.price;
          }
        }
        if (href) cta.href = href;
        cta.textContent = data.cta + (price != null ? ' · ' + money(price, data.money) : '');
        if (alt) alt.hidden = !(o.boardLink && books.bb && books.bb.exists);
      }

      occBtns.forEach(function (b, i) { b.addEventListener('click', function () { st.occ = i; render(); }); });
      bookBtns.forEach(function (b) { b.addEventListener('click', function () { st.book = b.getAttribute('data-sy-book'); render(); }); });
      tierBtns.forEach(function (b) { b.addEventListener('click', function () { st.tier = b.getAttribute('data-sy-tier'); render(); }); });
      render();
    });
  }

  /* ----------------------------------------------------- product builder */

  function initGallery() {
    $$('[data-sy-gallery]').forEach(function (g) {
      if (!once(g, 'bound')) return;
      var thumbs = $$('[data-sy-thumb]', g);
      g.syShow = function (src, alt) {
        var img = $('[data-sy-gal-main] img', g);
        if (!img || !src) return;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
        if (alt != null) img.alt = alt;
        press(thumbs, function (b) { return b.getAttribute('data-sy-thumb') === src; });
      };
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () { g.syShow(b.getAttribute('data-sy-thumb'), b.getAttribute('data-alt')); });
      });
    });
  }

  function initProduct() {
    $$('[data-sy-product]').forEach(function (root) {
      if (!once(root, 'bound')) return;
      var data = readJSON($('[data-sy-product-data]', root));
      var form = document.getElementById(root.getAttribute('data-form'));
      if (!data || !form) return;

      var V = data.variants || [];
      var si = data.sizeIndex, pi = data.pagesIndex;
      var tierMap = parseTiers(data.tiers);
      var idInput = $('[data-sy-variant]', root);
      var fallback = $('[data-sy-fallback]', root);
      if (fallback) fallback.disabled = true;

      var gallery = $('[data-sy-gallery]', root);
      var priceEl = $('[data-sy-price]', root);
      var specEl = $('[data-sy-spec]', root);
      var addBtn = $('[data-sy-add]', root);
      var errEl = $('[data-sy-err]', root);
      var pagesOut = $('[data-sy-pages]', root);
      var stepText = $('[data-sy-steptext]', root);
      var minus = $('[data-sy-step="-1"]', root);
      var plus = $('[data-sy-step="1"]', root);
      var sizeBtns = $$('[data-sy-size]', root);
      var tierBtns = $$('[data-sy-tier]', root);
      var optInputs = $$('[data-sy-opt]', root);
      var bar = document.querySelector('[data-sy-bar-watch="#' + form.id + '"]');
      var barPrice = bar && $('[data-sy-bar-price]', bar);
      var barSpec = bar && $('[data-sy-bar-spec]', bar);
      var barBtn = bar && $('button', bar);

      var cur = V.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || V[0];
      if (!cur) return;
      var opts = cur.options.slice();
      var query = new URLSearchParams(location.search);
      var tier = /^[sml]$/.test(query.get('photos') || '') ? query.get('photos') : (data.tier || 'm');

      function num(v) { return parseInt(v, 10) || 0; }
      function sameExcept(v, skip) {
        for (var i = 0; i < opts.length; i++) {
          if (i === skip) continue;
          if (v.options[i] !== opts[i]) return false;
        }
        return true;
      }
      // The page counts on sale for the current size, in order, every
      // `step` pages from the smallest.
      function lane() {
        if (pi < 0) return [];
        var vals = uniq(V.filter(function (v) { return sameExcept(v, pi); }).map(function (v) { return num(v.options[pi]); }))
          .sort(function (a, b) { return a - b; });
        if (data.step > 0 && vals.length) {
          var lo = vals[0], here = num(opts[pi]);
          vals = vals.filter(function (p) { return (p - lo) % data.step === 0 || p === here; });
        }
        return vals;
      }
      function variantFor(o) {
        return V.filter(function (v) {
          for (var i = 0; i < o.length; i++) if (v.options[i] !== o[i]) return false;
          return true;
        })[0] || null;
      }
      function applyTier() {
        if (pi < 0 || !tierMap) return;
        var size = si >= 0 ? opts[si] : Object.keys(tierMap)[0];
        var row = tierMap[size];
        if (!row) return;
        var target = row[TIER_INDEX[tier]];
        var vals = lane();
        if (!vals.length) return;
        opts[pi] = String(nearest(vals, target, function (p) { return p; }));
      }
      function priceAt(size) {
        var o = opts.slice();
        if (si >= 0) o[si] = size;
        if (pi >= 0) {
          var row = tierMap && tierMap[size];
          var vals = uniq(V.filter(function (v) {
            for (var i = 0; i < o.length; i++) if (i !== pi && v.options[i] !== o[i]) return false;
            return true;
          }).map(function (v) { return num(v.options[pi]); }));
          if (!vals.length) return null;
          var target = row ? row[TIER_INDEX[tier]] : num(opts[pi]);
          o[pi] = String(nearest(vals, target, function (p) { return p; }));
        }
        return variantFor(o);
      }

      function paint(push) {
        var v = variantFor(opts);
        errEl.textContent = '';
        if (v) {
          cur = v;
          idInput.value = v.id;
        }
        var ok = !!(v && v.available);

        var priceHtml = '';
        if (v && v.compare > v.price) priceHtml = '<del>' + money(v.compare, data.money) + '</del>';
        priceEl.innerHTML = priceHtml;
        priceEl.appendChild(document.createTextNode(v ? money(v.price, data.money) : '—'));

        var bits = [];
        if (pi >= 0) bits.push(opts[pi] + ' ' + (data.pagesWord || 'pages'));
        if (si >= 0) bits.push(opts[si]);
        opts.forEach(function (o, i) { if (i !== pi && i !== si && V.length > 1) bits.push(o); });
        bits.push('free shipping');
        specEl.textContent = bits.join(' · ');

        addBtn.disabled = !ok;
        addBtn.textContent = ok ? data.addLabel : data.soldOut;
        if (barPrice) barPrice.textContent = v ? money(v.price, data.money) : '—';
        if (barSpec) barSpec.textContent = bits.slice(0, -1).join(' · ');
        if (barBtn) barBtn.disabled = !ok;

        press(sizeBtns, function (b) { return b.getAttribute('data-sy-size') === opts[si]; });
        sizeBtns.forEach(function (b) {
          var pv = priceAt(b.getAttribute('data-sy-size'));
          var out = $('[data-sy-size-price]', b);
          if (out) out.textContent = pv ? money(pv.price, data.money) : '';
        });
        press(tierBtns, function (b) { return b.getAttribute('data-sy-tier') === tier; });

        if (pi >= 0) {
          var vals = lane();
          var here = vals.indexOf(num(opts[pi]));
          pagesOut.textContent = opts[pi];
          minus.disabled = here <= 0;
          plus.disabled = here < 0 || here >= vals.length - 1;
          if (vals.length > 1) {
            var a = variantFor(withPages(vals[0])), b = variantFor(withPages(vals[1]));
            var gap = vals[1] - vals[0];
            stepText.textContent = gap + ' at a time' + (a && b ? ' · ' + money(b.price - a.price, data.money) + ' each' : '');
          } else {
            stepText.textContent = '';
          }
        }

        if (v && v.media && gallery && gallery.syShow) gallery.syShow(v.media);

        if (push && v && window.history && history.replaceState) {
          var q = new URLSearchParams(location.search);
          q.set('variant', v.id);
          history.replaceState(null, '', location.pathname + '?' + q.toString() + location.hash);
        }
      }
      function withPages(p) { var o = opts.slice(); o[pi] = String(p); return o; }

      sizeBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          opts[si] = b.getAttribute('data-sy-size');
          if (tierMap) applyTier();
          else {
            var vals = lane();
            if (vals.length) opts[pi] = String(nearest(vals, num(opts[pi]), function (p) { return p; }));
          }
          paint(true);
        });
      });
      tierBtns.forEach(function (b) {
        b.addEventListener('click', function () { tier = b.getAttribute('data-sy-tier'); applyTier(); paint(true); });
      });
      [minus, plus].forEach(function (b) {
        if (!b) return;
        b.addEventListener('click', function () {
          var vals = lane();
          var here = vals.indexOf(num(opts[pi]));
          var next = vals[here + parseInt(b.getAttribute('data-sy-step'), 10)];
          if (next == null) return;
          opts[pi] = String(next);
          paint(true);
        });
      });
      optInputs.forEach(function (r) {
        r.addEventListener('change', function () { opts[+r.getAttribute('data-sy-opt')] = r.value; paint(true); });
      });

      // A link from the picker names the exact variant; otherwise the photo
      // count chosen at first decides the pages.
      if (!query.has('variant')) applyTier();
      paint(false);

      form.addEventListener('submit', function (e) {
        if (CART_CFG.drawer === false || !window.fetch) return;
        e.preventDefault();
        var btns = [addBtn, barBtn].filter(Boolean);
        btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
        fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) {
            return r.json().then(function (j) {
              if (!r.ok) throw new Error(j.description || j.message || '');
              return j;
            });
          })
          .then(function () { return Cart.open(); })
          .catch(function (err) { errEl.textContent = (err && err.message) || CART_CFG.labels.error || 'Please try again.'; })
          .then(function () {
            btns.forEach(function (b) { b.disabled = !(cur && cur.available); b.removeAttribute('aria-busy'); });
          });
      });
    });
  }

  /* ------------------------------------------------------------- the cart */

  var Cart = (function () {
    var L = CART_CFG.labels || {};
    var drawer = $('[data-sy-drawer]');
    var foot = drawer && $('[data-sy-drawer-foot]', drawer);
    var checkout = foot && $('[data-sy-checkout]', foot);
    var products = {};
    var back = null;
    var busy = false;

    var SWAP_KEY = 'sy-a4';
    function swaps() { try { return JSON.parse(sessionStorage.getItem(SWAP_KEY) || '{}'); } catch (e) { return {}; } }
    function saveSwaps(m) { try { sessionStorage.setItem(SWAP_KEY, JSON.stringify(m)); } catch (e) { /* private mode */ } }

    function api(url, body) {
      return fetch(url, body ? {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      } : { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || L.error);
          return j;
        });
      });
    }
    function get() { return api('/cart.js'); }
    function product(handle) {
      if (!products[handle]) products[handle] = api('/products/' + handle + '.js');
      return products[handle];
    }

    function setCount(n) {
      $$('[data-sy-count]').forEach(function (c) { c.textContent = n; c.hidden = !n; });
    }

    function img(src, w) {
      if (!src) return '';
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function line(it, n) {
      var row = el('div', 'sy-line');
      if (it.image) {
        var im = el('img', 'sy-line__img');
        im.src = img(it.image, 200);
        im.alt = it.product_title;
        im.width = 78; im.height = 78; im.loading = 'lazy';
        row.appendChild(im);
      }
      var main = el('div', 'sy-line__main');
      var a = el('a', 'sy-line__title', it.product_title);
      a.href = it.url;
      main.appendChild(a);
      if (!it.product_has_only_default_variant) {
        var opts = (it.options_with_values || []).map(function (o) {
          return /page/i.test(o.name) ? o.value + ' pages' : o.value;
        }).join(' · ');
        if (!opts && it.variant_title) opts = it.variant_title.replace(/ \/ /g, ' · ');
        if (opts) main.appendChild(el('span', 'sy-line__meta', opts));
      }
      Object.keys(it.properties || {}).forEach(function (k) {
        var v = it.properties[k];
        if (k.charAt(0) === '_' || v == null || v === '') return;
        main.appendChild(el('span', 'sy-line__meta', k + ': ' + v));
      });

      var r = el('div', 'sy-line__row');
      var q = el('div', 'sy-qty');
      var m = el('button', null, '−'); m.type = 'button'; m.setAttribute('aria-label', 'One fewer');
      var c = el('span', null, String(it.quantity));
      var p = el('button', null, '+'); p.type = 'button'; p.setAttribute('aria-label', 'One more');
      m.addEventListener('click', function () { change(n, it.quantity - 1); });
      p.addEventListener('click', function () { change(n, it.quantity + 1); });
      q.appendChild(m); q.appendChild(c); q.appendChild(p);
      r.appendChild(q);
      r.appendChild(el('span', 'sy-line__price', money(it.final_line_price)));
      main.appendChild(r);

      var rm = el('button', 'sy-line__remove', L.remove || 'Remove');
      rm.type = 'button';
      rm.addEventListener('click', function () { change(n, 0); });
      main.appendChild(rm);
      row.appendChild(main);
      return row;
    }

    // A5 ↔ A4 for one line, at the real price of the other variant.
    function upsell(box, it, n) {
      if (!CART_CFG.upsellA4 || !it.handle) return;
      var sw = swaps();
      product(it.handle).then(function (p) {
        var names = (p.options || []).map(function (o) { return (o.name || o || '').toLowerCase(); });
        var si = -1;
        names.forEach(function (nm, i) { if (nm.indexOf('size') > -1) si = i; });
        if (si < 0) return;
        var mine = (p.variants || []).filter(function (v) { return v.id === it.variant_id; })[0];
        if (!mine) return;
        var size = mine.options[si];
        var undo = sw[it.variant_id];
        var other = null;
        if (size === 'A5') {
          other = p.variants.filter(function (v) {
            return v.available && v.options.every(function (o, i) { return i === si ? o === 'A4' : o === mine.options[i]; });
          })[0];
        } else if (size === 'A4' && undo) {
          other = p.variants.filter(function (v) { return v.id === undo; })[0];
        }
        if (!other) return;

        var on = size === 'A4';
        var diff = Math.abs(other.price - mine.price);
        var rowEl = el('div', 'sy-upsell');
        var t = el('div', 'sy-upsell__text');
        t.appendChild(el('b', null, CART_CFG.a4Title));
        t.appendChild(el('span', null, (CART_CFG.a4Text ? CART_CFG.a4Text + ' ' : '') + money(diff) + ' more.'));
        var btn = el('button', 'sy-toggle', on ? (L.added || 'Added') : (L.add || 'Add'));
        btn.type = 'button';
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.addEventListener('click', function () {
          if (busy) return;
          busy = true;
          btn.disabled = true;
          // Remember which A5 an A4 came from, so "Added" can be undone.
          var m = swaps();
          if (on) delete m[mine.id]; else m[other.id] = mine.id;
          api('/cart/change.js', { line: n, quantity: 0 })
            .then(function () { return api('/cart/add.js', { items: [{ id: other.id, quantity: it.quantity, properties: it.properties || {} }] }); })
            .then(function () { saveSwaps(m); })
            .catch(function () {})
            .then(function () { busy = false; refresh(); });
        });
        rowEl.appendChild(t);
        rowEl.appendChild(btn);
        box.appendChild(rowEl);
      }).catch(function () {});
    }

    function gift(cart) {
      var on = cart.attributes && cart.attributes.Gift === 'Yes';
      var rowEl = el('div', 'sy-upsell');
      var t = el('div', 'sy-upsell__text');
      t.appendChild(el('b', null, CART_CFG.giftTitle));
      t.appendChild(el('span', null, CART_CFG.giftText));
      var btn = el('button', 'sy-toggle', on ? 'Yes' : (L.add || 'Add'));
      btn.type = 'button';
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.addEventListener('click', function () {
        btn.disabled = true;
        api('/cart/update.js', { attributes: { Gift: on ? '' : 'Yes' } }).catch(function () {}).then(refresh);
      });
      rowEl.appendChild(t);
      rowEl.appendChild(btn);
      return rowEl;
    }

    function after() {
      var box = el('div', 'sy-after');
      box.appendChild(el('p', 'sy-label sy-label--dark', CART_CFG.afterLabel));
      box.appendChild(el('p', null, CART_CFG.afterPay));
      return box;
    }

    function sum(cart) {
      var box = el('div', 'sy-sum');
      function row(a, b, cls) {
        var r = el('div', cls || null);
        r.appendChild(el('span', null, a));
        r.appendChild(el('b', null, b));
        box.appendChild(r);
      }
      row(L.book, money(cart.items_subtotal_price));
      row(L.design, L.included);
      row(L.shipping, L.free);
      row(L.total, money(cart.total_price), 'sy-sum__total');
      return box;
    }

    function empty() {
      var box = el('div', 'sy-drawer__empty');
      box.appendChild(el('b', 'sy-h3', CART_CFG.emptyTitle));
      box.appendChild(el('p', 'sy-muted', CART_CFG.emptyText));
      var a = el('a', 'sy-btn', CART_CFG.emptyButton);
      a.href = CART_CFG.shopUrl || '/';
      a.addEventListener('click', close);
      box.appendChild(a);
      return box;
    }

    function render(view, cart, mode) {
      view.textContent = '';
      if (!cart.item_count) {
        if (mode === 'page') { location.reload(); return; }
        view.appendChild(empty());
        if (foot) foot.hidden = true;
        return;
      }
      cart.items.forEach(function (it, i) { view.appendChild(line(it, i + 1)); });
      var ups = el('div');
      ups.style.display = 'contents';
      view.appendChild(ups);
      cart.items.forEach(function (it, i) { upsell(ups, it, i + 1); });
      if (CART_CFG.gift) view.appendChild(gift(cart));

      if (mode === 'drawer') {
        if (CART_CFG.afterPay) view.appendChild(after());
        view.appendChild(sum(cart));
        if (foot) foot.hidden = false;
        if (checkout) checkout.textContent = (L.checkout || 'Checkout') + ' · ' + money(cart.total_price);
      } else {
        var t = $('[data-sy-cartpage-total]'), s = $('[data-sy-cartpage-sub]');
        if (t) t.textContent = money(cart.total_price);
        if (s) s.textContent = money(cart.items_subtotal_price);
      }
    }

    function paintAll(cart) {
      setCount(cart.item_count);
      if (drawer && !drawer.hidden) render($('[data-sy-cart-view]', drawer), cart, 'drawer');
      var page = $('[data-sy-cart-page]');
      if (page) render(page, cart, 'page');
    }

    function refresh() { return get().then(paintAll).catch(function () {}); }

    function change(n, qty) {
      if (busy) return;
      busy = true;
      api('/cart/change.js', { line: n, quantity: Math.max(0, qty) })
        .then(paintAll)
        .catch(function () {})
        .then(function () { busy = false; });
    }

    function open() {
      if (!drawer) { location.href = CART_CFG.cartUrl || '/cart'; return Promise.resolve(); }
      back = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('sy-lock');
      var c = $('.sy-drawer__head [data-sy-drawer-close]', drawer);
      if (c) c.focus();
      return refresh();
    }
    function close() {
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true;
      document.body.classList.remove('sy-lock');
      if (back && back.focus) back.focus();
    }

    function init() {
      if (drawer) {
        $$('[data-sy-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      }
      var onCartPage = !!$('[data-sy-cart-page]');
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('[data-sy-cart-open]');
        if (!a || !drawer || CART_CFG.drawer === false || onCartPage) return;
        e.preventDefault();
        open();
      });
      // The chat assistant can add to the cart too.
      document.addEventListener('sz:cart-updated', refresh);
      if (onCartPage) refresh();
    }

    return { init: init, open: open, close: close, refresh: refresh };
  })();

  /* ---------------------------------------------------------------- boot */

  function boot() {
    initMenu();
    initHeroVideo();
    initBars();
    initTabs();
    initOpeners();
    initReels();
    initDates();
    initDateCheck();
    initPicker();
    initGallery();
    initProduct();
    Cart.init();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // The theme editor re-renders a section in place; run again for it.
  document.addEventListener('shopify:section:load', function () {
    initHeroVideo(); initTabs(); initDates(); initDateCheck(); initPicker(); initGallery(); initProduct(); initBars();
  });
})();
